import { render, staticRenderFns } from "./software.vue?vue&type=template&id=0f2fb89c&scoped=true"
import script from "./software.vue?vue&type=script&lang=js"
export * from "./software.vue?vue&type=script&lang=js"
import style0 from "./software.vue?vue&type=style&index=0&id=0f2fb89c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2fb89c",
  null
  
)

export default component.exports